export enum AreaPanelViewMode {
    List = 1,
    Form = 2,
}
